<template>
  <ToastModal
    ref="modal"
    :title="title"
    show-mobile-footer
    modal-id="DeleteWithNoLoginSuccess"
    @closed="onModalClose"
  >
    <div class="flex justify-center mb-5">
      <OSvg svg="checkmark-icon" />
    </div>
    <p class="o-body text-center mb-5" v-html="text" />
    <template v-slot:footer>
      <ToastModalFooter class="w-full" color="black" variant="outline" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import OSvg from '@/components/OSvg'

export default {
  name: 'DeleteWithNoLoginSuccess',
  components: {
    ToastModal,
    ToastModalFooter,
    OSvg
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleActivation () {
      this.$refs.modal.toggleActivation()
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
      this.$router.push('/')
    }
  }
}
</script>
